import React from 'react';
import templateData, { localsMessages } from '../utility/getTemplateData';
import { Row, Col } from '@paypalcorp/pp-react';
import ConfirmationBody from './ConfirmationBody';
import ConfirmationTitle from './ConfirmationTitle';
import ConfirmationView from './ConfirmationView';
import PendingWarning from '../components/PendingWarning';
import PropTypes from 'prop-types';
import withConfirmationData from './withConfirmationData';
import withConfirmationMessages from './withConfirmationMessages';
import withTheme from '../components/withTheme';
import isNna from '../utility/nna';

const messages = localsMessages('confirmation/pending');

function PendingView(props) {
  const { label } = messages;
  const { pending, pending2, pendingNna } = label;

  const bodyMessage = isNna(templateData.country) ? pendingNna : pending2;

  const PendingMessage = () => (
    <>
      <Row>
        <Col xs={12} className="text-center">
          <ConfirmationTitle message={pending} />
        </Col>
      </Row>
      <Row className="pending-content">
        <Col xs={12} className="text-center">
          <ConfirmationBody message={bodyMessage} />
        </Col>
      </Row>
    </>
  );

  return (
    <ConfirmationView
      {...props}
      accountMessage={messages.label.accountMessage}
      accountLink={messages.label.accountLink}
      engamentText={messages.label.engamentText}
      illustration={<PendingWarning />}
      message={<PendingMessage />}
    />
  );
}

PendingView.propTypes = {
  handleRedirect: PropTypes.func,
  orgName: PropTypes.string,
  returnTo: PropTypes.string,
  returnTextMember: PropTypes.string,
};

export default withConfirmationData(
  withConfirmationMessages(withTheme(PendingView), messages, 'pending')
);
